import {Injectable} from "@angular/core";
import {Versao} from "../../../domain/Versao";
import {AbstractHttpService} from "./AbstractHttpService";
@Injectable()
export class VersaoHttpService extends AbstractHttpService<Versao>{
  url = "/api/versao"
}
